import { render } from "./MentalBucket.vue?vue&type=template&id=798c3822"
import script from "./MentalBucket.vue?vue&type=script&lang=js"
export * from "./MentalBucket.vue?vue&type=script&lang=js"

import "./MentalBucket.vue?vue&type=style&index=0&id=798c3822&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__